<template>
  <div
    class="fhContainer flex items-center justify-center cursor-pointer"
    @click="emit('unFavorite')"
    data-test="favorite-heart"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="23"
      viewBox="0 0 26 23"
      fill="none"
    >
      <path
        d="M23.125 12.7031L14.0781 22.0781C13.4688 22.6875 12.4844 22.6875 11.9219 22.0781L2.82812 12.7031C0.203125 9.98438 0.34375 5.48438 3.29688 2.95312C5.82812 0.75 9.71875 1.17188 12.0625 3.5625L13 4.54688L13.8906 3.5625C16.2344 1.17188 20.0781 0.75 22.7031 2.95312C25.6094 5.48438 25.75 9.98438 23.125 12.7031Z"
        fill="#DC143C"
      />
    </svg>
  </div>
</template>

<script setup>
import { defineEmits } from 'vue';

const emit = defineEmits(['unFavorite']);
</script>

<style scoped>
.fhContainer {
  background: rgba(255, 255, 255, 0.32);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  transition: all 0.2s ease-in-out;
}

.fhContainer:hover {
  background: rgba(255, 255, 255, 0.6);
}
</style>
